import React from 'react'
import { useSelector } from 'react-redux'
import Route from 'route-parser'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import url from 'front-end-core/core/url'
import { MENU_ITEMS } from 'constants/menu'
import { URL_LOGOUT, URL_IDP_LOGIN, URL_DOC_DRAFTER_SAVED_DOCUMENTS } from 'constants/urls'
import { COMMENTS, USER_ADMIN, UTILS } from 'constants/controllers'
import selectEncryptionKeysLoaded from 'redux/selectors/selectEncryptionKeysLoaded'
import preLogout from 'helpers/preLogout'
import NavItem from 'components/layout/mobile-menu/NavItem'
import DropdownContainer, { ToggleDropdown } from './DropdownContainer'
import selectIsDocDrafter from 'redux/selectors/selectIsDocDrafter'
import selectIsFirmAdmin from 'redux/selectors/selectIsFirmAdmin'

const SavedDocsRoute = new Route(URL_DOC_DRAFTER_SAVED_DOCUMENTS)

const AccountMenu = ({ flavour, isLogged, isExternalAuth, aol }) => {
  const commentsAvailable = useSelector(selectEncryptionKeysLoaded)
  const isDocDrafter = useSelector(selectIsDocDrafter)
  const isFirmAdmin = useSelector(selectIsFirmAdmin)

  const _items = [...MENU_ITEMS]
    .reverse()
    .filter(curr => curr.target !== USER_ADMIN || isFirmAdmin)
    .reduce((acc, curr) => {
      if (curr.position === 'side-bottom') {
        return [...acc, curr]
      }

      if (curr.type === 'group') {
        return [...acc, ...curr.items]
      }

      return acc
    }, [])

  const items = commentsAvailable
    ? [
        ...MENU_ITEMS.filter(item => item.target === COMMENTS),
        ..._items
      ]
    : _items

  const linkClassName = 'tl db ph6 pv5 no-underline outline-0 focus-outline-0 hover-bg-ghost-grey b--lite-grey bb black'

  return (
    <ToggleDropdown dropdownId='account-menu-dropdown'>
      <div className='relative b--black ba pl7 pv4 pr4 black br2 pointer f5 fw5 nowrap flex justify-between items-center bg-transparent'>
        <span className='dib mr7 b no-select'>My Account</span>
        <ArrowDropDownIcon />
        <DropdownContainer id='account-menu-dropdown' className='z35 absolute bottom0 left0 right0 y-100 bg-white shadow-black-1'>
          <div className='flex flex-column h-100 overflow-y-auto'>
            <div className='nav-wrapper scroll-touch z5 w-100 grow-1 flex flex-column'>
              <ul className='list-reset pa0 ma0 grow-1'>
                {items.map((item, key) => (
                  <NavItem key={key} {...{ ...item, linkClassName }} />
                ))}
                {/* saved docs is only corp atm */}
                {isDocDrafter && aol === 'corporate' && (
                  <li className={linkClassName}>
                    <a
                      href={SavedDocsRoute.reverse({ aol })}
                      tabIndex='-1'
                      className='color-inherit no-underline'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Saved Documents
                    </a>
                  </li>
                )}
                {process.env.NODE_ENV === 'development' && (
                  <li className={linkClassName}>
                    <a
                      href={url(UTILS, { flavour })}
                      tabIndex='-1'
                      className='color-inherit no-underline'
                    >
                      Developer utils
                    </a>
                  </li>
                )}
                {!isExternalAuth && (
                  <li
                    data-event-category='Account'
                    data-event-action='Log out'
                  >
                    <a
                      className='tl db ph6 pv5 no-underline indian-red hover-bg-ghost-grey'
                      href={isLogged ? URL_LOGOUT : URL_IDP_LOGIN}
                      onClick={preLogout}
                      tabIndex='-1'
                    >
                      {isLogged ? 'Log out' : 'Log in'}
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </DropdownContainer>
      </div>
    </ToggleDropdown>
  )
}

export default AccountMenu
